/* eslint-disable no-undef */

import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Grid, Typography, CircularProgress, Box } from '@material-ui/core'
import QuestionPageFooter from '../views/partials/QuestionPageFooter'
import Terms from '../views/partials/Terms'

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    prelanderCompletedWrapper: {
        paddingTop: 10,
        paddingBottom: 20,
        paddingLeft: 40,
        width: 360,
        maxWidth: '100%',
        margin: 'auto',
        [theme.breakpoints.down(600)]: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 20
        }
    },
    title: {
        paddingTop: '0!important',
        fontWeight: 500,
        marginBottom: theme.spacing(2) + 'px!important',
        fontFamily: theme.fontFamily + '!important',
        textAlign: 'left!important'
    },
    description: {
        marginTop: theme.spacing(1) + 'px!important',
        fontSize: '1.25rem!important',
        paddingTop: '0!important',
        fontWeight: '400!important',
        fontFamily: theme.fontFamily + '!important',
        textAlign: 'left!important',
        [theme.breakpoints.down(600)]: {
            fontSize: '1.1rem!important'
        }
    },
    progress: {
        margin: theme.spacing(2)
    },
    completeIcon: {
        color: '#4caf50',
        marginRight: 4
    },
    spinnerIcon: {
        color: '#a3a5a3',
        marginRight: 11
    },
    progressCircle: {
        transition: 'none'
    }
})

class PrelanderComplete extends Component {
    state = {
        value: null,
        completed: 0
    }

    componentDidMount() {
        this.timer = setInterval(this.progress, 40)
    }

    componentWillUnmount() {
        clearInterval(this.timer)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.step !== this.props.step) {
            this.setState({ completed: 0 })
            clearInterval(this.timer)
            this.timer = setInterval(this.progress, 40)
        }
    }

    progress = () => {
        const { completed } = this.state
        if (completed >= 100) {
            clearInterval(this.timer)
        } else {
            this.setState({ completed: completed + (1000 / this.props.animationLenght) * 4 })
        }
    }

    render() {
        const { step, classes, prelander, questionPage, theme, layout } = this.props

        return (
            <>
                {prelander.completeAnimation === 'long' && (
                    <Grid container spacing={2} className={classes.root}>
                        {step === 0 && (
                            <Grid item xs={12}>
                                <div className={classes.prelanderCompletedWrapper + ' prelander-complated-wrapper'}>
                                    <Typography variant={'h4'} gutterBottom className={classes.title}>
                                        Kiitos vastauksistasi!
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        Vastauksia tarkistetaan...
                                    </Typography>
                                </div>
                            </Grid>
                        )}
                        {step === 1 && (
                            <Grid item xs={12}>
                                <div className={classes.prelanderCompletedWrapper + ' prelander-complated-wrapper'}>
                                    <Typography variant={'h4'} gutterBottom className={classes.title}>
                                        Kiitos vastauksistasi!
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> Vastaukset tarkistettu
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        Haetaan palkintoja...
                                    </Typography>
                                </div>
                            </Grid>
                        )}
                        {step === 2 && (
                            <Grid item xs={12}>
                                <div className={classes.prelanderCompletedWrapper + ' prelander-complated-wrapper'}>
                                    <Typography variant={'h4'} gutterBottom className={classes.title}>
                                        Kiitos vastauksistasi!
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> Vastaukset tarkistettu
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> 3 eri palkintoa löytyi
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        Varataan palkintoja...
                                    </Typography>
                                </div>
                            </Grid>
                        )}
                        {step === 3 && (
                            <Grid item xs={12}>
                                <div className={classes.prelanderCompletedWrapper + ' prelander-complated-wrapper'}>
                                    <Typography variant={'h4'} gutterBottom className={classes.title}>
                                        Kiitos vastauksistasi!
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> Vastaukset tarkistettu
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> 3 eri palkintoa varattu!
                                    </Typography>
                                </div>
                            </Grid>
                        )}
                        {step === 4 && (
                            <Grid item xs={12}>
                                <div className={classes.prelanderCompletedWrapper + ' prelander-complated-wrapper'}>
                                    <Typography variant={'h4'} gutterBottom className={classes.title}>
                                        Kiitos vastauksistasi!
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> Vastaukset tarkistettu
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> 3 eri palkintoa varattu!
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> Täytä tietosi seuraavalla sivulla
                                    </Typography>
                                </div>
                            </Grid>
                        )}
                        {step === 5 && (
                            <Grid item xs={12}>
                                <div className={classes.prelanderCompletedWrapper + ' prelander-complated-wrapper'}>
                                    <Typography variant={'h4'} gutterBottom className={classes.title}>
                                        Kiitos vastauksistasi!
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> Vastaukset tarkistettu
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> 3 eri palkintoa varattu!
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> Täytä tietosi seuraavalla sivulla
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> Siirrytään...
                                    </Typography>
                                </div>
                            </Grid>
                        )}
                        <Grid item xs={12} style={{ marginTop: -4 }}>
                            <CircularProgress className={classes.progress} variant="determinate" value={this.state.completed} />
                        </Grid>
                    </Grid>
                )}
                {prelander.completeAnimation === 'short' && (
                    <Grid container spacing={2} className={classes.root}>
                        {step === 0 && (
                            <Grid item xs={12}>
                                <div className={classes.prelanderCompletedWrapper + ' prelander-complated-wrapper'}>
                                    <Typography variant={'h4'} gutterBottom className={classes.title}>
                                        Kiitos vastauksistasi!
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> Kaikki vastaukset tarkistettu
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon size="xs" icon={['far', 'spinner-third']} spin className={classes.spinnerIcon} /> Varataan
                                        palkintoja...
                                    </Typography>
                                </div>
                            </Grid>
                        )}
                        {step === 1 && (
                            <Grid item xs={12}>
                                <div className={classes.prelanderCompletedWrapper + ' prelander-complated-wrapper'}>
                                    <Typography variant={'h4'} gutterBottom className={classes.title}>
                                        Kiitos vastauksistasi!
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> Kaikki vastaukset tarkistettu
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> 4 eri palkintoa varattu!
                                    </Typography>
                                </div>
                            </Grid>
                        )}
                        {step === 2 && (
                            <Grid item xs={12}>
                                <div className={classes.prelanderCompletedWrapper + ' prelander-complated-wrapper'}>
                                    <Typography variant={'h4'} gutterBottom className={classes.title}>
                                        Kiitos vastauksistasi!
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> Kaikki vastaukset tarkistettu
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> 4 eri palkintoa varattu!
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon className={classes.completeIcon} icon={['far', 'check']} /> Täytä tietosi seuraavalla sivulla
                                    </Typography>
                                    <Typography variant={'h5'} gutterBottom className={classes.description}>
                                        <FontAwesomeIcon size="xs" icon={['far', 'spinner-third']} spin className={classes.spinnerIcon} /> Siirrytään
                                        yhteystietoihin...
                                    </Typography>
                                </div>
                            </Grid>
                        )}
                        <Grid item xs={12} style={{ marginTop: -4 }}>
                            <CircularProgress
                                className={classes.progress}
                                variant="static"
                                value={Number(this.state.completed).toFixed(0)}
                                classes={{ circle: classes.progressCircle }}
                            />
                        </Grid>
                        {step !== 2 && (
                            <Grid item xs={12}>
                                <Box py={1}></Box>
                            </Grid>
                        )}
                    </Grid>
                )}
                {questionPage?.showFooter && <QuestionPageFooter />}
                {questionPage && questionPage.termsPosition === 'footer' ? (
                    <Terms domain={questionPage.domain} theme={theme} layout={layout} />
                ) : (
                    <Box mt={{ xs: 1, sm: 3 }} />
                )}
            </>
        )
    }
}

export default withStyles(styles)(PrelanderComplete)
